import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { Seo } from '@/components/generals/seo'
import { Wordmark } from '@/components/generals/brand'
import { studio } from '@/constants/fmg3d'

import Pending from '@/components/generals/pending'

const sections = [
    {
        title: 'Qué datos pedimos',
        text: 'Cuando pides una cotización nos dejas tu nombre, un correo o teléfono y la descripción de lo que necesitas. Si nos envías una foto o un boceto, también la recibimos.'
    },
    {
        title: 'Para qué los usamos',
        text: 'Solo para responder tu consulta, cotizar y coordinar el encargo. No los vendemos ni los compartimos con terceros para publicidad.'
    },
    {
        title: 'Cuánto tiempo los guardamos',
        text: 'Mientras dure la conversación y el encargo, y luego el tiempo que exija la ley.'
    },
    {
        title: 'Tus derechos',
        text: `Puedes pedirnos ver, corregir o borrar tus datos escribiendo a ${studio.email}.`
    }
]

/** Política de privacidad base, escrita en lenguaje simple. Debe revisarse antes de publicar. */
const PrivacyPage: FC = (): ReactNode => {
    return (
        <>
            <Seo title='Política de privacidad' description='Cómo FMG3D usa los datos que nos dejas al pedir una cotización.' noindex />
            <main className='mx-auto min-h-screen w-full max-w-2xl bg-background px-5 py-12 text-foreground sm:py-20'>
                <Link href='/' className='inline-flex min-h-11 items-center gap-2 text-sm font-medium underline underline-offset-4'>
                    <ArrowLeft aria-hidden='true' className='size-4' />
                    Volver
                </Link>
                <Wordmark className='mt-10 h-8' />
                <h1 className='mt-8 font-heading text-[clamp(2.4rem,6vw,3.6rem)] font-bold leading-none tracking-[-0.03em]'>Política de privacidad</h1>
                <p className='mt-4 text-sm text-muted-foreground'>Última actualización: <Pending>fecha por confirmar</Pending>. Texto base para revisar antes de publicar.</p>
                {sections.map((section) => (
                    <section key={section.title} className='mt-10'>
                        <h2 className='font-heading text-2xl font-semibold'>{section.title}</h2>
                        <p className='mt-3 text-[17px] leading-relaxed'>{section.text}</p>
                    </section>
                ))}
                <p className='mt-12 border-t border-foreground/15 pt-6 text-[15px] text-muted-foreground'>
                    {studio.name} · {studio.town}, {studio.province}, {studio.region}
                </p>
            </main>
        </>
    )
}

export default PrivacyPage
